import { Control } from "react-hook-form";
import { createContext, useContext } from "react";
import { useAdministerBulkMedication } from "../hooks/useAdministerBulkMedication";
import { BulkMedicationsFormFields } from "../../../services/api/types/medications/models/BulkMedicationsFormFields";
import { useResidentMedicationsContext } from "./ResidentMedicationsProvider";

interface Props {
  children: React.ReactNode;
  onFinishedBulkAdminister?: () => void;
  isPaginated?: boolean;
}

interface ResidentMedicationsContextType {
  control: Control<BulkMedicationsFormFields>;
  administerBulkMedication: (e?: React.BaseSyntheticEvent) => Promise<void>;
  isSubmitting: boolean;
}

const AdministerBulkMedicationsContext =
  createContext<ResidentMedicationsContextType>(
    {} as ResidentMedicationsContextType,
  );

export function AdministerBulkMedicationsProvider({
  children,
  onFinishedBulkAdminister,
}: Props) {

  const { data } = useResidentMedicationsContext();
  const { control, administerBulkMedication, isSubmitting } =
    useAdministerBulkMedication(data, { onFinishedBulkAdminister });

  return (
    <AdministerBulkMedicationsContext.Provider value={{ control, administerBulkMedication, isSubmitting }}>
      {children}
    </AdministerBulkMedicationsContext.Provider>
  );
}

export function useAdministerBulkMedicationsContext() {
  const context = useContext(AdministerBulkMedicationsContext);
  if (!context) {
    throw new Error(
      "useAdministerBulkMedicationsContext must be used within AdministerBulkMedicationsProvider",
    );
  }
  return context;
}
